import LandingPageIntegrations from '@/app/components/LandingPage/LandingPageIntegrations';

const ScienceAndResearchIntegrations = (): JSX.Element => {
  return (
    <section data-cy="science-and-research-integrations">
      <LandingPageIntegrations
        integrations={[
          {
            description: 'science_and_research_testimonials_one_description',
            name: '20+ PhDs',
            title: 'science_and_research_testimonials_one_title',
          },
          {
            description: 'science_and_research_testimonials_two_description',
            name: '3.8B Nights',
            title: 'science_and_research_testimonials_two_title',
          },
          {
            description: 'science_and_research_testimonials_three_description',
            name: '10+ Years',
            title: 'science_and_research_testimonials_three_title',
          },
        ]}
      />
    </section>
  );
};

export default ScienceAndResearchIntegrations;
